import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Divider,
    IconButton,
} from "@mui/material";
import SoftButton from "../../components/SoftButton";
import PropTypes from "prop-types";
import { IoClose } from "react-icons/io5";

const ConfirmationDialog = ({ open, title, message, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                id="form-dialog-title"
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                <Typography variant="h5" component="span" fontWeight="bold">
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <IoClose size={20} />
                </IconButton>
            </DialogTitle>

            <Divider />
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <Divider />
            <DialogActions>
                <SoftButton onClick={onClose} variant="contained" color="light">
                    Cancel
                </SoftButton>
                <SoftButton onClick={onConfirm} variant="contained" color="primary">
                    Confirm
                </SoftButton>
            </DialogActions>
        </Dialog>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationDialog;
